// Mock data for Ha Transport (Blacklane-style site)

export const services = [
  {
    id: 'standard',
    nameFr: 'Standard',
    nameEn: 'Standard',
    shortNameFr: 'Standard',
    shortNameEn: 'Standard',
    pax: '1-4',
    luggage: '2-3',
    maxPax: 4,
    maxLuggage: 4,
    descFr: 'Notre gamme accessible avec Tesla Model 3 : 100% électrique, silencieuse et technologique. L\u2019expérience VTC moderne à prix juste.',
    descEn: 'Our accessible range with Tesla Model 3: fully electric, silent and tech-forward. The modern chauffeur experience at the right price.',
    image: 'https://images.unsplash.com/photo-1625062516527-fe101f0ef1ab?w=1200&q=85&auto=format&fit=crop',
    examples: 'Tesla Model 3'
  },
  {
    id: 'berline-vip',
    nameFr: 'Berline VIP',
    nameEn: 'VIP Sedan',
    shortNameFr: 'Berline',
    shortNameEn: 'Sedan',
    pax: '1-2',
    luggage: '2-4',
    maxPax: 2,
    maxLuggage: 4,
    descFr: 'Voyagez dans le confort absolu d\u2019une Mercedes Classe E 2025 noire avec chauffeur professionnel.',
    descEn: 'Travel in absolute comfort in a 2025 black Mercedes E-Class with a professional chauffeur.',
    image: 'https://customer-assets.emergentagent.com/job_ha-transport/artifacts/mi085qg5_IMG_7974.jpeg',
    examples: 'Mercedes Classe E 2025'
  },
  {
    id: 'classe-v',
    nameFr: 'Mercedes Classe V',
    nameEn: 'Mercedes V-Class',
    shortNameFr: 'Van',
    shortNameEn: 'Van',
    pax: '1-8',
    luggage: '5-10',
    maxPax: 8,
    maxLuggage: 10,
    descFr: 'Le van VIP par excellence. Idéal pour les groupes, familles ou hommes d\u2019affaires souhaitant voyager ensemble dans un raffinement total.',
    descEn: 'The VIP van par excellence. Ideal for groups, families or business travelers wishing to travel together in total refinement.',
    image: 'https://customer-assets.emergentagent.com/job_ha-transport/artifacts/a3o3yjr0_IMG_7961.jpeg',
    examples: 'Mercedes Classe V'
  },
  {
    id: 'van-sprinter',
    nameFr: 'Van Sprinter',
    nameEn: 'Sprinter Van',
    shortNameFr: 'Sprinter',
    shortNameEn: 'Sprinter',
    pax: '12-28',
    luggage: '12-28',
    maxPax: 28,
    maxLuggage: 28,
    descFr: 'Mercedes Sprinter aménagé pour vos déplacements de groupe en toute sérénité. Sièges confort, climatisation, Wi-Fi.',
    descEn: 'Mercedes Sprinter fitted for group travel with peace of mind. Comfort seats, A/C, Wi-Fi onboard.',
    image: 'https://customer-assets.emergentagent.com/job_ha-transport/artifacts/qdu1r7ab_IMG_7960.jpeg',
    examples: 'Mercedes Sprinter VIP'
  },
  {
    id: 'minibus',
    nameFr: 'Minibus',
    nameEn: 'Minibus',
    shortNameFr: 'Minibus',
    shortNameEn: 'Minibus',
    pax: '17-30',
    luggage: '17-25',
    maxPax: 30,
    maxLuggage: 25,
    descFr: 'Le compromis idéal pour les groupes moyens : équipes sportives, séminaires, mariages, événements privés.',
    descEn: 'The ideal balance for medium-sized groups: sports teams, seminars, weddings and private events.',
    image: 'https://images.unsplash.com/photo-1570125909517-53cb21c89ff2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHx0b3VyJTIwYnVzfGVufDB8fHx8MTc3ODA2NjcyNHww&ixlib=rb-4.1.0&q=85',
    examples: 'Iveco, Mercedes Tourer'
  },
  {
    id: 'autocar',
    nameFr: 'Autocar Grand Tourisme',
    nameEn: 'Coach',
    shortNameFr: 'Autocar',
    shortNameEn: 'Coach',
    pax: '40-60',
    luggage: '40-60',
    maxPax: 60,
    maxLuggage: 60,
    descFr: 'Autocar grand tourisme jusqu\u2019à 60 places, idéal pour vos voyages longue distance, séminaires d\u2019entreprise et excursions touristiques.',
    descEn: 'Premium coach up to 60 seats, ideal for long-distance trips, corporate seminars and sightseeing tours.',
    image: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHx0b3VyJTIwYnVzfGVufDB8fHx8MTc3ODA2NjcyNHww&ixlib=rb-4.1.0&q=85',
    examples: 'Setra, Mercedes Travego'
  }
];

export const cities = [
  { name: 'Paris', country: 'France', image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&q=80' },
  { name: 'Roissy CDG', country: 'France', image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80' },
  { name: 'Orly', country: 'France', image: 'https://images.unsplash.com/photo-1559023234-1e773470544f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxPcmx5JTIwYWlycG9ydHxlbnwwfHx8fDE3NzgxNDA5ODd8MA&ixlib=rb-4.1.0&q=85' },
  { name: 'Le Bourget', country: 'France', image: 'https://images.unsplash.com/photo-1619659085985-f51a00f0160a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxwcml2YXRlJTIwamV0fGVufDB8fHx8MTc3ODE0MDk4N3ww&ixlib=rb-4.1.0&q=85' },
  { name: 'Disneyland Paris', country: 'France', image: 'https://images.unsplash.com/photo-1598961336118-93106a3cab26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxEaXNuZXlsYW5kJTIwUGFyaXMlMjBjYXN0bGV8ZW58MHx8fHwxNzc4MTQxOTY5fDA&ixlib=rb-4.1.0&q=85' },
  { name: 'Lille', country: 'France', image: 'https://images.unsplash.com/photo-1568797629192-b6e9bc4ff4d2?w=800&q=80' },
  { name: 'Lyon', country: 'France', image: 'https://images.unsplash.com/photo-1677088294485-65750d3aab45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxMeW9uJTIwYmFzaWxpY2F8ZW58MHx8fHwxNzc4MTQwOTg3fDA&ixlib=rb-4.1.0&q=85' },
  { name: 'Bruxelles', country: 'Belgium', image: 'https://images.unsplash.com/photo-1559113202-c916b8e44373?w=800&q=80' },
  { name: 'Londres', country: 'UK', image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800&q=80' }
];

export const useCases = [
  {
    id: 'airport',
    keyFr: 'Transferts aéroport',
    keyEn: 'Airport transfers',
    descFr: 'Suivi de vol, accueil personnalisé, attente offerte 60 min.',
    descEn: 'Flight tracking, meet & greet, 60 min complimentary wait.',
    image: 'https://customer-assets.emergentagent.com/job_ha-transport/artifacts/23azyoea_IMG_7975.webp'
  },
  {
    id: 'business',
    keyFr: 'Voyages d\u2019affaires',
    keyEn: 'Business travel',
    descFr: 'Discrétion, ponctualité et confort pour vos rendez-vous professionnels.',
    descEn: 'Discretion, punctuality and comfort for every business appointment.',
    image: 'https://images.unsplash.com/photo-1616804947838-6646ae0e423d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjaGF1ZmZldXJ8ZW58MHx8fHwxNzc4MDY2NzA0fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'events',
    keyFr: 'Mariages & événements',
    keyEn: 'Weddings & events',
    descFr: 'Une flotte élégante pour les moments qui comptent.',
    descEn: 'An elegant fleet for the moments that matter.',
    image: 'https://images.unsplash.com/photo-1558222209-134191edfe0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjaGF1ZmZldXJ8ZW58MHx8fHwxNzc4MDY2NzA0fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'hourly',
    keyFr: 'Mise à disposition',
    keyEn: 'Chauffeur hailing',
    descFr: 'Un chauffeur dédié, à l\u2019heure ou à la journée.',
    descEn: 'A dedicated chauffeur, by the hour or by the day.',
    image: 'https://images.unsplash.com/photo-1603087462214-2aadc739429c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBjaGF1ZmZldXJ8ZW58MHx8fHwxNzc4MDY2NzA0fDA&ixlib=rb-4.1.0&q=85'
  }
];

export const testimonials = [
  {
    id: 1,
    nameFr: 'Sophie L.',
    nameEn: 'Sophie L.',
    role: 'CEO, Paris',
    quoteFr: 'Service irréprochable. Chauffeur en costume, voiture impeccable, ponctualité parfaite. Ha Transport est devenu mon partenaire exclusif.',
    quoteEn: 'Flawless service. Suited chauffeur, immaculate car, perfect punctuality. Ha Transport has become my exclusive partner.'
  },
  {
    id: 2,
    nameFr: 'Marc D.',
    nameEn: 'Marc D.',
    role: 'Directeur événementiel',
    quoteFr: 'Nous avons fait appel pour un séminaire de 50 personnes. Le minibus et l\u2019autocar étaient irréprochables.',
    quoteEn: 'We hired them for a 50-person seminar. Both the minibus and the coach were spotless.'
  },
  {
    id: 3,
    nameFr: 'Aïcha M.',
    nameEn: 'Aicha M.',
    role: 'Voyageuse fréquente',
    quoteFr: 'Mon transfert CDG est toujours une expérience apaisante. Je recommande à 100%.',
    quoteEn: 'My CDG transfer is always a soothing experience. 100% recommended.'
  }
];

export const faqs = [
  {
    qFr: 'Comment réserver un chauffeur ?',
    qEn: 'How do I book a chauffeur?',
    aFr: 'Vous pouvez réserver via notre formulaire en ligne, par téléphone au +33 7 51 28 41 24 ou par email à ha.transport33@gmail.com.',
    aEn: 'You can book via our online form, by phone +33 7 51 28 41 24 or by email at ha.transport33@gmail.com.'
  },
  {
    qFr: 'Quels modes de paiement acceptez-vous ?',
    qEn: 'Which payment methods do you accept?',
    aFr: 'Carte bancaire, virement, espèces et facturation entreprise sur demande.',
    aEn: 'Credit card, bank transfer, cash, and corporate billing on request.'
  },
  {
    qFr: 'Le suivi de vol est-il inclus ?',
    qEn: 'Is flight tracking included?',
    aFr: 'Oui, pour tous les transferts aéroport, avec attente offerte de 60 min.',
    aEn: 'Yes, for every airport transfer, with 60 minutes of complimentary waiting time.'
  },
  {
    qFr: 'Intervenez-vous hors Île-de-France ?',
    qEn: 'Do you operate outside Paris region?',
    aFr: 'Oui, partout en France et en Europe sur réservation.',
    aEn: 'Yes, anywhere in France and Europe on request.'
  }
];

export const excursions = [
  {
    id: 'giverny',
    nameFr: 'Giverny',
    nameEn: 'Giverny',
    region: 'Normandie',
    distance: '~80 km de Paris',
    descFr: 'Visitez la maison et les jardins de Claude Monet, un incontournable pour les amateurs d\u2019art impressionniste.',
    descEn: 'Visit Claude Monet\u2019s house and gardens, a must-see for impressionist art lovers.',
    image: 'https://images.unsplash.com/photo-1775566532861-3e8381e63265?w=1200&q=80&auto=format&fit=crop',
    youtubeId: 'jzsnfkcbkXg'
  },
  {
    id: 'normandie',
    nameFr: 'Plages du D\u00e9barquement',
    nameEn: 'D-Day Landing Beaches',
    region: 'Calvados, Normandie',
    distance: '~3h de Paris',
    descFr: 'Omaha Beach, Utah Beach, le M\u00e9morial de Caen et le cimeti\u00e8re am\u00e9ricain de Colleville-sur-Mer.',
    descEn: 'Omaha Beach, Utah Beach, the Caen Memorial and the American Cemetery at Colleville-sur-Mer.',
    image: 'https://images.unsplash.com/photo-1687599428919-d5e1d7872226?w=1200&q=80&auto=format&fit=crop',
    youtubeId: 'TMhUWnQrGd8'
  },
  {
    id: 'mont-saint-michel',
    nameFr: 'Mont-Saint-Michel',
    nameEn: 'Mont-Saint-Michel',
    region: 'Normandie',
    distance: '~4h de Paris',
    descFr: 'L\u2019une des merveilles de France, abbaye millénaire pos\u00e9e sur la baie.',
    descEn: 'One of France\u2019s wonders, a thousand-year-old abbey on its bay.',
    image: 'https://images.unsplash.com/photo-1609925110680-9850c3c6d440?w=1200&q=80&auto=format&fit=crop',
    youtubeId: 'jHcaV_QF9rQ'
  },
  {
    id: 'bretagne',
    nameFr: 'Bretagne',
    nameEn: 'Brittany',
    region: 'Saint-Malo, Dinan, Cancale',
    distance: '~4h30 de Paris',
    descFr: 'Cit\u00e9s corsaires, c\u00f4tes sauvages et gastronomie iodée. Une escapade authentique.',
    descEn: 'Privateer cities, wild coasts and seafood gastronomy. An authentic getaway.',
    image: 'https://images.unsplash.com/photo-1605851721771-90e372f38e8a?w=1200&q=80&auto=format&fit=crop',
    youtubeId: 'Q48tv_VC8JE'
  },
  {
    id: 'chambord',
    nameFr: 'Ch\u00e2teau de Chambord',
    nameEn: 'Ch\u00e2teau de Chambord',
    region: 'Loire',
    distance: '~2h de Paris',
    descFr: 'Le plus vaste des ch\u00e2teaux de la Loire, chef-d\u2019\u0153uvre de la Renaissance fran\u00e7aise.',
    descEn: 'The largest of the Loire ch\u00e2teaux, a masterpiece of the French Renaissance.',
    image: 'https://images.unsplash.com/photo-1709805773958-40279d36069f?w=1200&q=80&auto=format&fit=crop',
    youtubeId: 'OvzzriowD64'
  },
  {
    id: 'loire',
    nameFr: 'Ch\u00e2teaux de la Loire',
    nameEn: 'Loire Valley Castles',
    region: 'Chenonceau, Amboise, Villandry',
    distance: '~2h30 de Paris',
    descFr: 'Une journ\u00e9e ou plusieurs jours \u00e0 la d\u00e9couverte des plus beaux ch\u00e2teaux de France.',
    descEn: 'A day or more discovering France\u2019s most beautiful castles.',
    image: 'https://images.unsplash.com/photo-1665308018141-41b8ae0887bb?w=1200&q=80&auto=format&fit=crop',
    youtubeId: 'Nurhqiw3FgU'
  },
  {
    id: 'champagne-epernay',
    nameFr: 'Champagne \u2013 \u00c9pernay',
    nameEn: 'Champagne \u2013 \u00c9pernay',
    region: 'Avenue de Champagne',
    distance: '~1h30 de Paris',
    descFr: 'Visite des grandes maisons : Mo\u00ebt & Chandon, Perrier-Jou\u00ebt, De Castellane. D\u00e9gustations privées.',
    descEn: 'Visit the great houses: Mo\u00ebt & Chandon, Perrier-Jou\u00ebt, De Castellane. Private tastings.',
    image: 'https://images.unsplash.com/photo-1636540133014-0a1a0a9639f1?w=1200&q=80&auto=format&fit=crop',
    youtubeId: 'Uq0BL-u7jVM'
  },
  {
    id: 'reims',
    nameFr: 'Reims & Maisons de Champagne',
    nameEn: 'Reims & Champagne Houses',
    region: 'Veuve Clicquot, Taittinger, Pommery',
    distance: '~1h30 de Paris',
    descFr: 'Cath\u00e9drale du sacre des rois et caves de prestige creus\u00e9es dans la craie.',
    descEn: 'Coronation cathedral and prestigious chalk cellars.',
    image: 'https://images.unsplash.com/photo-1632854270303-f5fdb97b697f?w=1200&q=80&auto=format&fit=crop',
    youtubeId: '2RIs7h03GeI'
  },
  {
    id: 'versailles',
    nameFr: 'Ch\u00e2teau de Versailles',
    nameEn: 'Palace of Versailles',
    region: 'Yvelines',
    distance: '~30 min de Paris',
    descFr: 'La galerie des Glaces, les jardins de Le N\u00f4tre et le Trianon \u2014 sans la foule.',
    descEn: 'The Hall of Mirrors, Le N\u00f4tre\u2019s gardens and the Trianon \u2014 without the crowds.',
    image: 'https://images.unsplash.com/photo-1591828353335-197466da2a4e?w=1200&q=80&auto=format&fit=crop',
    youtubeId: 'lhqmJJI6Rec'
  },
  {
    id: 'provence',
    nameFr: 'Provence & C\u00f4te d\u2019Azur',
    nameEn: 'Provence & French Riviera',
    region: 'Aix, Avignon, Cannes, Saint-Tropez',
    distance: 'Sur demande',
    descFr: 'Itin\u00e9raires sur mesure pour vos s\u00e9jours dans le sud de la France.',
    descEn: 'Tailor-made itineraries for your stays in the south of France.',
    image: 'https://images.unsplash.com/photo-1723916687481-8b64bbfb56e1?w=1200&q=80&auto=format&fit=crop',
    youtubeId: 'TU3MT5X3aZ4'
  }
];

export const company = {
  name: 'Ha Transport',
  address: '3 Avenue Charles de Gaulle, 95700 Roissy-en-France',
  phone: '+33 7 51 28 41 24',
  email: 'ha.transport33@gmail.com'
};
